// 资源包条目缩略图:有 coverThumbUrl(封面 or 图片自身缩略)出 img,否则回退 FileIcon。
// 三处包文件列表共用(pack-files-view / share-pack / pack-manage)。
import { FileIcon } from './file-icon'
import { resourceUrl } from '../_lib/resource-node-pref'

export function PackItemThumb({
  coverThumbUrl,
  type,
  name,
  mimeType,
  size = 44,
  iconSize = 20,
}: {
  coverThumbUrl?: string | null | undefined
  type: string
  name: string
  mimeType?: string | null | undefined
  size?: number
  iconSize?: number
}) {
  if (coverThumbUrl) {
    return (
      <span
        className="shrink-0 overflow-hidden rounded-lg bg-[#F1F2F4]"
        style={{ width: size, height: size }}
      >
        <img src={resourceUrl(coverThumbUrl)} alt="" loading="lazy" className="h-full w-full object-cover" />
      </span>
    )
  }
  return <FileIcon type={type} name={name} mimeType={mimeType} size={size} iconSize={iconSize} />
}
